/** Phase 234 — Tracks the **direction** of the last route change so the
 * page-transition CSS can slide left (forward) or right (back).
 * 
 * Approach: history.state has an `idx` integer. We remember the previous
 * idx in a ref; if the new idx is lower, we treat the navigation as
 * "back" and add the `pwa-page-back` class on the next render. */

import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

export function useNavDirection() {
  const location = useLocation();
  const lastIdxRef = useRef(null);
  const [direction, setDirection] = useState("forward");

  useEffect(() => {
    const idx = (window.history.state && window.history.state.idx) ?? 0;
    if (lastIdxRef.current !== null && idx < lastIdxRef.current) {
      setDirection("back");
    } else {
      setDirection("forward");
    }
    lastIdxRef.current = idx;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return direction;
}
